mutation DeleteHifoCascade($id: ID!) {
  deleteHifoCascade(input: { id: $id }) {
    success
  }
}
